/* eslint-disable react-hooks/exhaustive-deps */
import ModalAddOrEditAddress from './ModalAddOrEditAddress';
import UploadImageContainer from './UploadImageContainer';
import {
  ArrowDown,
  CreateNewIcon,
  RadioActiveIcon,
  RadioInactiveIcon,
} from '@/assets/svg';
import { uploadImage } from '@/firebase';
import { renderUnitNumber } from '@/helpers';
import { CustomFormHelperText } from '@/module/all-screenings/component/ViewPatientRegistration/ModalInputServices';
import { LIST_ETHNIC_GROUP } from '@/module/clinic-appointment/component/PatientInformationStep';
import { CustomAutocomplete } from '@/module/company/component/CreateAndEditCompany/styled';
import patientDispatcher from '@/module/patient/actions';
import { NATIONALITY } from '@/module/patient/constants';
import { ClearComponent } from '@/new-components/ClearComponent';
import CustomDate from '@/new-components/CustomDate';
import CustomLoadingButton from '@/new-components/CustomLoadingButton';
import CustomModalTitle from '@/new-components/CustomModal/CustomModalTitle';
import customToast from '@/new-components/CustomNotification';
import CustomSelectContainer from '@/new-components/CustomSelectOld/CustomSelectContainer';
import {
  checkRegexFullName,
  validateIdentity,
  validateNRIC,
} from '@/utils/validation';
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  Paper,
  Radio,
  TextField,
  Typography,
  withStyles,
  Chip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { get, isEmpty, isEqual } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';

export const GENDERS = [
  {
    value: 'Male',
    key: 'Male',
  },
  {
    value: 'Female',
    key: 'Female',
  },
];

export const IDENTITY_TYPE = [
  {
    key: 'NRIC',
    value: 'NRIC/FIN',
  },
  {
    key: 'Passport',
    value: 'Passport',
  },
];

const CustomPaper = withStyles((theme) => ({
  root: {
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent',
    },

    '& .MuiAutocomplete-option': {
      padding: 8,
      borderRadius: 8,
      margin: '2px 8px',
      '&:first-child': {
        marginTop: 8,
      },
      '&:last-child': {
        marginBottom: 8,
      },
      '&.MuiAutocomplete-option[aria-selected="true"]': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
}))(Paper);

const CustomTextField = withStyles({
  root: {
    fontSize: 20,
    width: '100%',

    '& .MuiOutlinedInput-root': {
      height: 48,
      borderRadius: 8,
    },
    '& .MuiOutlinedInput-input': {
      marginRight: (props) => (props.hasClear ? 0 : 30),
      padding: '8px 5px',
      fontSize: 16,
    },

    '& .Mui-disabled': {
      '&.MuiOutlinedInput-root': {
        backgroundColor: '#f6f6f6',
      },
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
    '& .MuiInputBase-multiline': {
      height: 'auto',
      paddingLeft: 0,

      '& .MuiOutlinedInput-input': {
        marginRight: 8,
      },
    },
  },
})(TextField);

const CustomCard = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    minHeight: 88,
    cursor: 'pointer',

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: `1px solid #ccc`,
    borderRadius: 12,

    '& .card-icon': {
      width: 72,
      height: 72,
      color: '#ccc',
    },

    '& .card-text': {
      fontSize: 16,
      fontFamily: 'OpenSans',
      color: '#191919',
    },

    '&:hover': {
      '& .card-icon': {
        color: theme.palette.primary.main,
      },

      '&.MuiPaper-outlined': {
        border: `1px solid ${theme.palette.primary.main}`,
      },
    },

    '&.selected': {
      '&.MuiPaper-outlined': {
        border: `1px solid ${theme.palette.primary.main}`,
      },
    },
  },
}))(Card);

const CustomChip = withStyles({
  root: {
    color: '#AD5E99',
    backgroundColor: '#FFE9FB',
    marginBottom: 8,
  },
})(Chip);

const CustomTitleLabel = withStyles({
  root: {
    fontSize: 16,
    fontWeight: 600,
    color: '#333333',
  },
})(Typography);

const CustomTitleSubLabel = withStyles({
  root: {
    fontWeight: 600,
    color: '#666666',
  },
})(Typography);

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    height: 'calc(100vh - 140px)',
    overflow: 'auto',
  },
  stepsControlWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1),
  },
}));

const TYPE_MODAL = {
  Create: 'create',
  Edit: 'edit',
};

const ModalAddDependentProfile = ({
  onClose,
  onSubmit,
  loading,
  selectedItem,
}) => {
  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const [openModalEditAddress, setOpenModalEditAddress] = useState(false);
  const [listAddress, setListAddress] = useState([]);
  const [typeModal, setTypeModal] = useState(TYPE_MODAL.Create);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedAddress, setSelectedAddress] = useState({});
  const [formValue, setFormValue] = useState({
    fullName: '',
    dateOfBirth: '',
    gender: '',
    identityType: '',
    lstIdentityUrl: [],
    identityNumber: '',
    parentId: '',
    ethnicGroup: 'Others',
    nationality: '',
    notificationEmail: '',
    address: '',
    unitNumber: '',
    postalCode: '',
    floor: '',
    ignoredUnitNumber: false,
  });

  const handleChangeForm = (key) => (e, newValue) => {
    let value = get(e, 'target.value');
    switch (key) {
      case 'frontCorperatePlan':
      case 'backCorperatePlan':
        const FILE_SIZE = 2 * 1024 * 1024; // ~2mb
        if (get(e, 'size') > FILE_SIZE) {
          customToast('error', 'Image is too large');
          return;
        }
        value = e;
        break;

      case 'dateOfBirth':
        value = moment(e).startOf('date').format();
        break;

      case 'nationality':
        value = newValue;
        break;

      case 'identityType':
        setFormValue({
          ...formValue,
          [key]: get(e, 'target.value'),
          identityNumber: '',
        });
        return;

      default:
        break;
    }

    setFormValue({ ...formValue, [key]: value });
  };

  const validCompleteProfile = (data) => {
    let valid = true;
    let errors = {};

    if (formValue.identityNumber) {
      const validIdentityNumber =
        formValue.identityType === 'NRIC'
          ? validateNRIC(formValue.identityNumber)
          : validateIdentity(formValue.identityNumber);

      if (!validIdentityNumber) {
        errors = { ...errors, identityNumber: 'Identity Number is invalid!' };
        valid = false;
      }
    }

    if (formValue.fullName) {
      const isValidFullName = checkRegexFullName(formValue.fullName);
      if (!isValidFullName) {
        errors = {
          ...errors,
          fullName:
            'Full Name must contain letters only or letters combined with special characters',
        };
        valid = false;
      }
    }

    setErrors(errors);
    return valid;
  };

  const handleSubmit = async () => {
    // const frontCorperatePlan = formValue.frontCorperatePlan;
    // const backCorperatePlan = formValue.backCorperatePlan;

    // try {
    //   if (
    //     frontCorperatePlan?.constructor === File &&
    //     backCorperatePlan?.constructor === File
    //   ) {
    //     let fontUrl = await uploadImage(frontCorperatePlan);
    //     let backUrl = await uploadImage(backCorperatePlan);

    //     onSubmit({ ...formValue, lstIdentityUrl: [fontUrl, backUrl] });
    //   }
    // } catch (error) {
    //   console.error('Failed to upload files:', error);
    // }
    if (!validCompleteProfile(formValue)) {
      return;
    }
    setErrors({});
    onSubmit(formValue);
  };

  const handleSubmitAddress = async (data) => {
    if (typeModal === TYPE_MODAL.Create) {
      console.log('create', selectedItem);
      patientDispatcher.createUserAddress(data, () => {
        setOpenModalEditAddress(false);
        patientDispatcher.getUserAddress(selectedItem.id, (data) => {
          setListAddress(data);
          const mainAddress = data.find((it) => it.isDefault);
          if (mainAddress && data.length === 1) {
            setSelectedAddress(mainAddress);
            setFormValue({
              ...formValue,
              address: mainAddress.address,
              unitNumber: mainAddress.unitNumber,
              postalCode: mainAddress.postalCode,
              floor: mainAddress.floor,
              ignoredUnitNumber: mainAddress.ignoredUnitNumber,
            });
          }
        });
      });
    } else {
      patientDispatcher.editUserAddress(data, () => {
        setOpenModalEditAddress(false);
        patientDispatcher.getUserAddress(selectedItem.id, (data) => {
          setListAddress(data);
        });
      });
    }
  };

  const isEmptyParams = useMemo(() => {
    const filterKeys = [
      'fullName',
      'dateOfBirth',
      'gender',
      'identityType',
      'identityNumber',
      'postalCode',
      'address',
    ];

    let valid = false;
    // Unit Number

    const checkValid = filterKeys.some((key) => !formValue[key]);
    return checkValid || valid;
  }, [formValue]);

  const AddressInput = ({ onClick, onEdit, data }) => {
    return (
      <CustomCard
        variant="outlined"
        onClick={() => onClick(data)}
        className={isEqual(selectedAddress?.id, data?.id) ? 'selected' : ''}
      >
        <Box display="flex" alignItems="center">
          <Radio
            checked={isEqual(selectedAddress?.id, data?.id)}
            color="primary"
            icon={<RadioInactiveIcon />}
            checkedIcon={<RadioActiveIcon />}
          />
          <Box>
            {data.isDefault && (
              <CustomChip
                size="small"
                label="Main delivery address"
                color="primary"
              />
            )}
            <Typography className="card-text">
              {[
                data?.address,
                isEmpty(data?.floor) && isEmpty(data?.unitNumber)
                  ? null
                  : `#${renderUnitNumber(data?.floor, data?.unitNumber)}`,
                data?.postalCode ? `Singapore ${data.postalCode}` : null,
              ]
                .filter(Boolean)
                .join(', ')}
            </Typography>
          </Box>
        </Box>
        <Button color="primary" onClick={onEdit} style={{ minWidth: 55 }}>
          Edit
        </Button>
      </CustomCard>
    );
  };

  useEffect(() => {
    if (selectedItem) {
      setIsLoading(true);
      patientDispatcher.getUserAddress(selectedItem.id, (data) => {
        setListAddress(data);
        const mainAddress = data.find((it) => it.isDefault);
        if (mainAddress) {
          setSelectedAddress(mainAddress);
          setFormValue({
            ...formValue,
            notificationEmail: selectedItem.notificationEmail,
            parentId: selectedItem.id,
            address: mainAddress.address,
            unitNumber: mainAddress.unitNumber,
            postalCode: mainAddress.postalCode,
            floor: mainAddress.floor,
            ignoredUnitNumber: mainAddress.ignoredUnitNumber,
          });
        } else
          setFormValue({
            ...formValue,
            notificationEmail: selectedItem.notificationEmail,
            parentId: selectedItem.id,
          });
        setIsLoading(false);
      });
    }
  }, []);

  return (
    <Paper square elevation={0}>
      <CustomModalTitle onClose={onClose}>
        Dependent Profile Information
      </CustomModalTitle>

      <main className={classes.mainWrapper}>
        <Box p={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <CustomTitleLabel>Personal Information</CustomTitleLabel>
            </Grid>
            <Grid item xs={6}>
              <CustomTitleSubLabel>Full Name as per NRIC</CustomTitleSubLabel>

              <CustomTextField
                id="fullName"
                fullWidth
                variant="outlined"
                placeholder="Enter full name as per NRIC"
                value={formValue.fullName || ''}
                onChange={handleChangeForm('fullName')}
                error={!!errors?.fullName}
                helperText={
                  !!errors.fullName
                    ? errors.fullName
                    : 'This will be reflected in all documents (eg receipt, MC etc)'
                }
                InputProps={{
                  endAdornment: (
                    <ClearComponent
                      id="fullName"
                      value={formValue.fullName}
                      onClear={() =>
                        setFormValue({ ...formValue, fullName: '' })
                      }
                    />
                  ),
                }}
              />
            </Grid>

            <Grid item xs={6}>
              <CustomTitleSubLabel>Date of birth</CustomTitleSubLabel>
              <CustomDate
                selectedDate={formValue.dateOfBirth}
                isFullWidth
                placeholder="DD/MM/YYYY"
                clearable={false}
                onChange={handleChangeForm('dateOfBirth')}
                maxDate={moment()}
                style={{ height: 48, fontFamily: 'OpenSans', fontSize: 16 }}
              />
            </Grid>

            <Grid item xs={6}>
              <CustomTitleSubLabel>Gender</CustomTitleSubLabel>
              <CustomSelectContainer
                data={GENDERS || []}
                height="48px"
                fontSize="16px"
                colorInput="#000000de"
                isMutiple={false}
                hideClear
                placeholder="Select Gender"
                renderValue={
                  formValue.gender
                    ? GENDERS.find((it) => it.key === formValue.gender)?.value
                    : 'Select Gender'
                }
                filterValue={formValue.gender || ''}
                onChange={handleChangeForm('gender')}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomTitleSubLabel>Notification email</CustomTitleSubLabel>
              <CustomTextField
                fullWidth
                variant="outlined"
                placeholder="Enter email address"
                value={formValue.notificationEmail || ''}
                error={errors.notificationEmail}
                helperText={errors.notificationEmail}
                onChange={handleChangeForm('notificationEmail')}
                InputProps={{
                  endAdornment: (
                    <ClearComponent
                      id="notificationEmail"
                      value={formValue.notificationEmail}
                      onClear={() =>
                        setFormValue({ ...formValue, notificationEmail: '' })
                      }
                    />
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Divider light />
            </Grid>

            <Grid item xs={12}>
              <CustomTitleLabel>Identification</CustomTitleLabel>
            </Grid>

            <Grid item xs={6}>
              <CustomTitleSubLabel>ID type</CustomTitleSubLabel>
              <CustomSelectContainer
                data={IDENTITY_TYPE || []}
                height="48px"
                fontSize="16px"
                isMutiple={false}
                hideClear
                colorInput="#000000de"
                placeholder="Select ID type"
                renderValue={
                  formValue.identityType
                    ? IDENTITY_TYPE.find(
                        (it) => it.key === formValue.identityType
                      )?.value
                    : 'Select ID type'
                }
                filterValue={formValue.identityType || ''}
                onChange={handleChangeForm('identityType')}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomTitleSubLabel>ID number</CustomTitleSubLabel>
              <CustomTextField
                id="identityNumber"
                fullWidth
                variant="outlined"
                placeholder="Enter number"
                value={formValue.identityNumber || ''}
                onChange={handleChangeForm('identityNumber')}
                error={!!errors?.identityNumber}
                helperText={errors?.identityNumber}
                InputProps={{
                  endAdornment: (
                    <ClearComponent
                      id="identityNumber"
                      value={formValue.identityNumber}
                      onClear={() =>
                        setFormValue({ ...formValue, identityNumber: '' })
                      }
                    />
                  ),
                }}
              />
            </Grid>
            {/* <Grid item xs={12}>
              <CustomTitleSubLabel>ID images</CustomTitleSubLabel>
              <Box display="flex" gridGap={24}>
                <Box flex={1}>
                  <UploadImageContainer
                    keyName="frontCorperatePlan"
                    label="Front of card"
                    imageUrl={formValue.frontCorperatePlan}
                    handleChangeForm={handleChangeForm}
                    formValue={formValue}
                    setFormValue={setFormValue}
                  />
                </Box>
                <Box flex={1}>
                  <UploadImageContainer
                    keyName="backCorperatePlan"
                    label="Back of card"
                    imageUrl={formValue.backCorperatePlan}
                    handleChangeForm={handleChangeForm}
                    formValue={formValue}
                    setFormValue={setFormValue}
                  />
                </Box>
              </Box>

              <CustomFormHelperText>
                Photo ID is required for regulatory compliance, and will be kept secure.
                Please refer to our{' '}
                <a
                  className="custom-link"
                  href="https://minmed.sg/privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </CustomFormHelperText>
            </Grid> */}

            <Grid item xs={6}>
              <CustomTitleSubLabel>Nationality</CustomTitleSubLabel>
              <CustomAutocomplete
                getOptionSelected={(option, value) => option === value}
                options={NATIONALITY || []}
                value={formValue.nationality || ''}
                onChange={handleChangeForm('nationality')}
                popupIcon={<ArrowDown />}
                renderInput={(params) => (
                  <CustomTextField
                    variant="outlined"
                    placeholder="Select Nationality"
                    {...params}
                  />
                )}
                disableClearable
                PaperComponent={({ children, ...other }) => (
                  <CustomPaper {...other}>{children}</CustomPaper>
                )}
              />
              {errors.nationality && (
                <CustomFormHelperText error>
                  {errors.nationality}
                </CustomFormHelperText>
              )}
            </Grid>

            <Grid item xs={6}>
              <CustomTitleSubLabel>Ethnic group</CustomTitleSubLabel>
              <CustomSelectContainer
                data={LIST_ETHNIC_GROUP || []}
                height="48px"
                fontSize="16px"
                isMutiple={false}
                hideClear
                colorInput="#000000de"
                placeholder="Select ethnic group"
                renderValue={
                  formValue.ethnicGroup
                    ? LIST_ETHNIC_GROUP.find(
                        (it) => it.key === formValue.ethnicGroup
                      )?.value
                    : 'Select ethnic group'
                }
                filterValue={formValue.ethnicGroup || ''}
                onChange={handleChangeForm('ethnicGroup')}
              />

              {errors.ethnicGroup && (
                <CustomFormHelperText error>
                  {errors.ethnicGroup}
                </CustomFormHelperText>
              )}
            </Grid>
            <Grid item xs={12}>
              <Divider light />
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between">
                <CustomTitleLabel>Address Details</CustomTitleLabel>
              </Box>
            </Grid>
            {!isEmpty(listAddress) &&
              !isLoading &&
              listAddress.map((it) => (
                <Grid item xs={6}>
                  <AddressInput
                    key={it.id}
                    data={it}
                    onClick={(value) => {
                      setSelectedAddress(it);
                      setFormValue({
                        ...formValue,
                        address: it.address,
                        unitNumber: it.unitNumber,
                        postalCode: it.postalCode,
                        floor: it.floor,
                        ignoredUnitNumber: it.ignoredUnitNumber,
                      });
                    }}
                    onEdit={() => {
                      setSelectedAddress(it);
                      setTypeModal('edit');
                      setOpenModalEditAddress(true);
                    }}
                  />
                </Grid>
              ))}
            <Grid item xs={12}>
              <Button
                startIcon={<CreateNewIcon />}
                color="primary"
                onClick={() => {
                  setTypeModal(TYPE_MODAL.Create);
                  setSelectedAddress({});
                  setOpenModalEditAddress(true);
                }}
              >
                Add new address
              </Button>
            </Grid>
          </Grid>
        </Box>
      </main>

      <Box
        display="flex"
        justifyContent="flex-end"
        py={1.75}
        px={1.25}
        gridGap={16}
        borderTop={'1px solid #E0E0E0'}
      >
        <CustomLoadingButton
          variant="outlined"
          color="primary"
          onClick={onClose}
        >
          Cancel
        </CustomLoadingButton>

        <CustomLoadingButton
          variant="contained"
          color="primary"
          loading={loading}
          disabled={isEmptyParams || loading}
          onClick={handleSubmit}
        >
          Save
        </CustomLoadingButton>
      </Box>
      {openModalEditAddress && (
        <ModalAddOrEditAddress
          parentId={selectedItem.id}
          selectedAddress={selectedAddress}
          typeModal={typeModal}
          open={openModalEditAddress}
          onClose={() => setOpenModalEditAddress(false)}
          onSubmit={handleSubmitAddress}
        />
      )}
    </Paper>
  );
};

ModalAddDependentProfile.propTypes = {
  loading: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  selectedItem: PropTypes.object,
};

ModalAddDependentProfile.defaultProps = {
  loading: false,
  open: false,
  onClose: () => console.warn('Not implemented yet'),
  onSubmit: () => console.warn('Not implemented yet'),
  selectedItem: null,
};

export default ModalAddDependentProfile;
